import { Grid, Slider } from "@mui/material";
import { PricesStorage, PriceTier } from "e.sic-platform.webclient/src/services/shop/PricesStorage";
import { observer } from "mobx-react-lite";
import { useCallback, useMemo } from "react";

export default observer(function PriceStepper(props: {pricesStorage: PricesStorage, coins: number}) {
    const {coins, pricesStorage} = props;
    var steps = pricesStorage.maximumCoins / pricesStorage.totalTiers;

    const closest = (array: any[], value: number) => {
        return array.reduce((prev, next) =>
            Math.abs(next - value) < Math.abs(prev - value) ? next : prev
        );
    };

    const scale = useCallback((value: number) => {
        if (value === 0) return 0;
        var index = Math.floor(value / steps);
        var tier = pricesStorage.prices[index];
        if (tier) {
            var quotient = value / steps % 1;
            var diff = tier.maximum - tier.minimum;
            var newValue = quotient * diff + tier.minimum;
            return Math.round(newValue + 1);
        } else return 0
    }, [steps])

    const values = useMemo(() => Array.from(Array(pricesStorage.maximumCoins)).map((value: number, index: number) => scale(index)), []);

    const value = useMemo(() => values.indexOf(closest(values, coins)), [coins, values]);

    var markLabels = [...pricesStorage.prices.map((pt: PriceTier) => {return {value: pt.id * steps, label: pt.maximum + 1 + " Credits"}}), {value: 0, label: 0}];
    var marks = markLabels.map((value: any) => value.value);
    pricesStorage.prices.forEach((pt: PriceTier) => markLabels.push({value: (pt.id - 1) * steps + (steps / 2), label: pt.discount + "%"}))

    return (
        <>
            <Grid item xs={12} className="centered">
                <Slider sx={{ '& .MuiSlider-markLabel': {
                     top: -15, // Moves the marks above the slider
                }}} 
                disabled 
                valueLabelFormat={scale} min={pricesStorage.minimumCoins} max={pricesStorage.maximumCoins} value={marks} marks={markLabels}/>
            </Grid>
            <Grid item xs={12} className="centered">
                <Slider valueLabelFormat={scale} valueLabelDisplay="on" value={value} min={pricesStorage.minimumCoins} max={pricesStorage.maximumCoins - 1} />
            </Grid>
        </>
    )
})